import { Form } from 'factorial-form'
import _ from 'lodash'

class ObservationForm extends Form {
  constructor(values: Record<string, any>) {
    super(values, {
      id: 'string',
      observation_text: 'string',
      effective_on: 'date',
      employee_id: 'string',
      payroll_policy_period_id: 'string',
    })
  }

  get handoffData() {
    const data = this.data()

    const attrs = _.pick(data, [
      'observation_text',
      'id',
      'employee_id',
      'payroll_policy_period_id',
    ])

    return { ...attrs }
  }
}

export default ObservationForm
